module.exports = __webpack_public_path__ + "img/arash-razavi-tawny.0d30f71.jpg";